import ChapterDisplay from './ChapterDisplay';
import Comments from './Comments';

export default function Capitulo10() {
    const section = 'el-ataque-de-camazotz';
    const title = 'El ataque de Camazotz';
    const description = 'El partido se interrumpió por la llegada de Camazotz';
    const text = '<p>Un murciélago gigante y malvado destruyó todo el estadio. Me salvé gracias a Choc, mi golem de piedra, y a la ayuda de Mictlantecuhtli, que nos teletransportó a la salida al mundo de los vivos. El problema es que la llave para abrir la puerta no estaba, y la única opción era ir al reino de Camazotz para buscar otra salida.</p><p>El Mictlán quedó en ruinas por la furia del murciélago, y cuando llegamos a la estación de las estelas para escapar, ¡ya no servían! Una ráfaga de aire me tiró a la estela, y aunque mis amigos me siguieron, me separé de ellos. Un rayo me sacó de la estela y ahora todo es oscuro. ¡No sé dónde estoy! ¡Qué miedo!</p>';
    const image = '';
    const image_number = 'https://www.diadelavida.com/images/numbers/10.png'
    const image_size = 'contain';
    const image_position = 'center';
    const image_height = 0;
    const comments_prompt = '¿Qué harías si estuvieras en el lugar de Valentina? ¿Cómo crees que pueda salir de este lío? ¡Deja tu comentario!';

    const images = [
        {
            id: 1,
            src: 'https://www.diadelavida.com/images/chapters/capitulo10_main.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 10',
            description: '¡Ahora Valentina está perdida de verdad...'
        },
        {
            id: 2,
            src: 'https://diadelavida.com/images/cards/card_choc_01.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 10',
            description: 'El más fiel de los compañeros, ¡Choc siempre me cuida!'
        },
    ];

    return (
        <div>
            <ChapterDisplay
                section={section}
                title={title}
                description={description}
                text={text}
                image={image}
                imageSize={image_size}
                imagePosition={image_position}
                imageHeight={image_height}
                images={images}
                imageNumber={image_number}
            />
            <div id='users-comments'>
                <div className="comments-deco"></div>
                <div className="container">
                    <div className="row">
                        <Comments sectionId={section} commentsPrompt={comments_prompt} />
                    </div>
                </div>
            </div>
        </div>
    );
}